import { useCallback } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/providers/auth-provider";

export function useSignInAgain(returnTo: string): () => void {
  const navigate = useNavigate();
  const { logout } = useAuth();
  return useCallback(() => {
    logout();
    navigate({ to: "/login", search: { redirect: returnTo } });
  }, [logout, navigate, returnTo]);
}
